import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { SorterResult } from 'antd/lib/table';
import Spin from 'src/components/common/Spin';
import { AuditItem } from 'src/components/ErrorMonitoring/types/scriptConfiguration';
import { ColumnSorting, getColumns, AuditItemColumn } from './AuditTable.config';
import styles from './AuditTable.module.less';

export type AuditTableProps = {
  items: AuditItem[];
  sorting: ColumnSorting;
  loading: boolean;
  onSortingChange: (sorting: ColumnSorting) => void;
};

export const AuditTable: React.FC<AuditTableProps> = ({ items, sorting, loading, onSortingChange }) => {
  const [columns, setColumns] = useState<AuditItemColumn[]>([]);

  const emptyText: React.ReactNode = <p className={styles.noResults}>No results found.</p>;

  useEffect(() => {
    setColumns(getColumns(sorting));
  }, [sorting]);

  const handleSorterChange = (_: unused, __: unused, sorter: SorterResult<AuditItem>): void => {
    const order =
      sorting.field === sorter.columnKey && sorter.order === undefined
        ? sorting.order === 'ascend'
          ? 'descend'
          : 'ascend'
        : sorter.order;

    onSortingChange({ field: sorter.columnKey as keyof AuditItem, order: order });
  };

  return (
    <Spin spinning={loading}>
      <Table
        className={styles.listTable}
        columns={columns}
        dataSource={items}
        onChange={handleSorterChange}
        tableLayout={'auto'}
        locale={{ emptyText }}
        pagination={false}
        scroll={{ x: false, y: 'calc(100vh - 200px)' }}
      />
    </Spin>
  );
};
